// extracted by mini-css-extract-plugin
module.exports = {"heroHome":"Home_heroHome__2EaS5","mainTitle":"Home_mainTitle__om0cV","bold":"Home_bold__Nuurj","heroImg":"Home_heroImg__18Zmz"};